export default "__VITE_ASSET__DHI9mTPc__"